import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {
    gridArea: 'toolbar',
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
    zIndex: theme.zIndex.appBar,
  },
}));

/**
 * @description A layout slot that spans the main content and right rail columns.
 */
export default function Toolbar({ children }: { children: React.ReactNode }) {
  const { classes } = useStyles();

  return <Box className={classes.root}>{children}</Box>;
}
